<template>
	<div id="app">
		<router-view/>
	</div>
</template>
<script>
	export default {
		name: 'App',
		components: {},
		watch: {
			$route() {
				window.scrollTo(0, 0);
			}
		}
	}
</script>
<style lang="scss">
	@import "assets/sass/app";
</style>